import Paging from '@Components/MuiWrappers/Paging';
import TranslationText from '@Components/Utilities/TranslationText';
import translator from '@Components/Utilities/Translator';

const ArchiveView = (props) => {

    const pageChange = (page) => {
        window.location = window.location.pathname + '?page=' + page;
    };

    return (
        <div className='newsstand-content'>
            <div className='inner-wrap main-content'>
                <div className='di-title border-bottom'>
                    <h1><span className='di-title italic'>{props.Title}</span> <TranslationText tKey='sandhills.tradepubwebsite.mvc.digitaleditions' /></h1>
                    <a id='archive-page-newsstand-link' href={props.NewsstandURL}><TranslationText tKey='sandhills.tradepubwebsite.mvc.viewnewsstand' /></a>
                </div>
                <section className='di-compact'>
                    {props.DigitalIssues && props.DigitalIssues.length > 0 && props.DigitalIssues.map((issue) =>
                        <div key={issue.DigitalIssue.DigitalIssueID} className='di-container column3'>
                            <div className='di-img-outer'>
                                {issue.RedirectToArchive ?
                                    <a href={issue.ArchiveUrl} className='di-img-inner'>
                                        <img src={issue.DigitalIssue.CoverImageURL} className='di-img' alt={issue.DigitalIssue.IssueName + ' ' + translator.translate('sandhills.coverpreview')} />
                                    </a>
                                    :
                                    <a href={issue.DigitalIssue.IssueURL} className='di-image-outer' target='_blank'>
                                        <img src={issue.DigitalIssue.CoverImageURL} className='di-img' alt={issue.DigitalIssue.IssueName + ' ' + translator.translate('sandhills.coverpreview')} />
                                        <span className='visually-hidden'>({translator.translate('sandhills.opensinanewtab')})</span>
                                    </a>}
                            </div>
                            {!issue.ShowOnlyImages &&
                                <div className='di-info'>
                                    <div className='di-edition-name'>{issue.ProperEditionName}</div>
                                    {(issue.DigitalIssue.IssueName.toLowerCase() !== 'sandhills magazine') &&
                                        <div className='di-region'>{issue.DisplayRegionName}</div>}
                                    <div className='di-issue-date'>{issue.DisplayIssueDate}</div>
                                </div>}
                        </div>)}
                </section>
            </div>
            {props.Pagination.TotalPages > 1 &&
                <Paging
                    currentPage={props.Pagination.CurrentPage}
                    totalPages={props.Pagination.TotalPages}
                    onChange={pageChange}
                />}
        </div>
    );
};

export default ArchiveView;
global.ArchiveView = ArchiveView;